// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "styles/" + "main" + "." + "724ffaf4b9a15c63dc54" + ".css";
};